module.exports = __webpack_public_path__ + "static/media/tournament-bg-elipse.975779bb.svg";